import React, { useEffect, useState } from 'react';
import { Input, AutoComplete, Row, Col, Popover } from 'antd'; // Select
import PropTypes from 'prop-types';
import FeatherIcon from 'feather-icons-react';
import { TopToolBoxClone3 } from '../../styled';

// const { Option } = Select;

const AutoCompletes = ({ dataSource, setAccess, access, setSendTo, allDetails }) => {
    const [options, setOptions] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);
    const [inputValue, setInputValue] = useState('');
    const [open, setOpen] = useState(false);
    const normalizeValue = (value) => {
        if (value == null) return null;
        const trimmed = value?.trim?.();
        if (trimmed === "") return "";
        return trimmed ?? value;
    };
    const handleSearch = (value) => {
        setInputValue(value);

        const selectedUserIds = Array.isArray(allDetails) && allDetails.length > 0
            ? allDetails.map(user => user.shareWith)
            : [];

        if (value) {
            const searchValue = normalizeValue(value)
            const filteredOptions = dataSource
                .filter(option => selectedUserIds.length === 0 || !selectedUserIds.includes(option.Cvalue))
                .filter(option =>
                    normalizeValue(option.firstName)?.toLowerCase().includes(searchValue.toLowerCase()) ||
                    normalizeValue(option.lastName)?.toLowerCase().includes(searchValue.toLowerCase()) ||
                    normalizeValue(option.username)?.toLowerCase().includes(searchValue.toLowerCase()) ||
                    normalizeValue(option.userGroupName)?.toLowerCase().includes(searchValue.toLowerCase())
                )
                .map(option => ({
                    value: option.Cvalue,
                    label: (
                        <div className='d-flex align-items-start'>
                            <div className='diplay-center'>
                                {option.Ctype === "user" && option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                    <img style={{ width: '30px', height: '30px', marginRight: '10px', borderRadius: 15 }}
                                        src={option.profilePic}
                                        alt="User Avatar"
                                    />
                                    :
                                    <span className={`image_icon ${option.Ctype === "user" ? "UserIcon" : "GroupIcon"}`} style={{ width: '30px', height: '30px', marginRight: '10px', borderRadius: 15 }}>
                                        {option.Ctype === "user" ? option.firstName.slice(0, 1).toUpperCase() :
                                            option.userGroupName.slice(0, 1).toUpperCase()}
                                    </span>
                                }
                            </div>

                            {option.Ctype === "user" ? <div>
                                <p style={{ fontWeight: 'bold', margin: 0 }}>{option.firstName} {option.lastName}</p>
                                <p style={{ margin: 0 }}>{option.username}</p>  </div> : <div>
                                <p style={{ fontWeight: 'bold', margin: 0 }}>{option.userGroupName}</p>
                                <p style={{ margin: 0 }}>{option.groupUserCount} Users (User Group)</p> </div>}

                            <div className='div_last'>
                                {selectedItems.some(item => item.id === option.Cvalue) && (
                                    <FeatherIcon icon="check" size={15} className="Svg" />
                                )}
                            </div>
                        </div>
                    ),
                }));
            setOptions(filteredOptions);
        } else {
            setOptions([]);
        }
    };
    const handleSelect = (id) => {
        const selectedItem = dataSource.find(item => item.Cvalue === id);
        if (selectedItem) {
            if (selectedItems.some(item => item.id === id)) {
                setSelectedItems(selectedItems.filter(item => item.id !== id));
            } else {
                setSelectedItems([...selectedItems, { id, item: selectedItem }]);
            }
            setInputValue('');
            setOptions([]);
        }
    };
    const handleDeselect = (id) => {
        setSelectedItems(selectedItems.filter(item => item.id !== id));
    };
    const handleOpenChange = (newOpen) => {
        setOpen(newOpen);
    };
    const Action = (
        <div className='Flex_div'>
            <div className='Flex_divs' role="button" style={{ cursor: 'pointer' }} tabIndex={0} onKeyDown={(event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                    setAccess('Read')
                }
            }}
                onClick={() => { setAccess('Read'); handleOpenChange(false) }}
            >
                <div className='text_icon' style={{ width: "20px" }}>
                    {access === "Read" &&
                        <FeatherIcon icon="check" size={20} className="Svg" />
                    }
                </div>
                <div className='text_icon'>
                    <FeatherIcon icon="eye" size={20} className="text_iconspaces1" /> <span className='text_iconspaces'>Can view</span>
                </div>
            </div>
            <div className='Flex_divs' role="button"
                style={{ cursor: 'pointer' }}
                tabIndex={0}
                onKeyDown={(event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                        setAccess('Read,Update')
                    }
                }}
                onClick={() => { setAccess('Read,Update'); handleOpenChange(false) }}>
                <div className='text_icon' style={{ width: "20px" }}>
                    {access === "Read,Update" &&
                        <FeatherIcon icon="check" size={20} className="Svg" />
                    }
                </div>
                <div className='text_icon'>
                    <FeatherIcon icon="edit" size={20} className="text_iconspaces1" /> <span className='text_iconspaces'>Can view and update</span>
                </div>
            </div>
            <div className='Flex_divs' role="button"
                style={{ cursor: 'pointer' }}
                tabIndex={0}
                onKeyDown={(event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                        setAccess('Read,Update,Delete')
                    }
                }}
                onClick={() => { setAccess('Read,Update,Delete'); handleOpenChange(false) }}>
                <div className='text_icon' style={{ width: "20px" }}>
                    {access === "Read,Update,Delete" &&
                        <FeatherIcon icon="check" size={20} className="Svg" />
                    }</div>
                <div className='text_icon'>
                    <FeatherIcon icon="file-minus" size={20} className="text_iconspaces1" /> <span className='text_iconspaces'>Can view, update and delete</span>
                </div>
            </div>
            {/* <div className='Flex_divs' role="button"
                style={{ cursor: 'pointer' }}
                tabIndex={0}
                onKeyDown={(event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                        setAccess('Read,Update,Delete,Sharing')
                    }
                }}
                onClick={() => { setAccess('Read,Update,Delete,Sharing'); handleOpenChange(false) }}>
                <div className='text_icon' style={{ width: "20px" }}>
                    {access === "Read,Update,Delete,Sharing" &&
                        <FeatherIcon icon="check" size={20} className="Svg" />
                    }</div>
                <div className='text_icon'>
                    <FeatherIcon icon="share-2" size={20} className="text_iconspaces1" /> <span className='text_iconspaces'> Can view, update, delete and share</span>
                </div>
            </div> */}
        </div>
    )
    useEffect(() => {
        // const ids = selectedItems.map(item => item.id).join(',');
        setSendTo(selectedItems);
    }, [selectedItems]);
    return (
        <Row className='Share_Div' gutter={30}>
            <Col span={2} className='Col_padding'>
                <FeatherIcon icon="users" size={20} style={{ color: "#b7bfca" }} />
            </Col>
            <Col span={19}>
                {selectedItems.length > 0 &&
                    <div className='Div_flex'>
                        {selectedItems.map(({ id, item }) => (
                            <div className='share_image' key={id} title={item.Ctype} style={{ cursor: "default" }}>
                                {item.Ctype === "user" && item.profilePic !== null && item.profilePic !== undefined && item.profilePic !== "" ?
                                    <img
                                        src={item.profilePic}
                                        alt="User Avatar"
                                    />
                                    :
                                    <span className={`image_icon2 ${item.Ctype === "user" ? "UserIcon" : "GroupIcon"}`} >
                                        {item.Ctype === "user" ? item.firstName.slice(0, 1).toUpperCase() :
                                            item.userGroupName.slice(0, 1).toUpperCase()}
                                    </span>
                                }
                                {item.Ctype === "user" ?
                                    <span>{item.firstName} {item.lastName}</span> :
                                    <span>{item.userGroupName}</span>}
                                <FeatherIcon icon="x" size={15} className="Svg" onClick={() => handleDeselect(id)} />
                            </div>
                        ))}
                    </div>
                }
                <TopToolBoxClone3>
                    <AutoComplete
                        style={{ width: 475 }}
                        onSearch={handleSearch}
                        onSelect={handleSelect}
                        options={options}
                        value={inputValue}
                        onChange={setInputValue}
                    >
                        <Input placeholder="Select users....." />
                    </AutoComplete>
                </TopToolBoxClone3>
            </Col>
            <Col span={3} className='Dropdown_tag'>
                <Popover className='text_icon'
                    placement="bottomRight"
                    content={Action}
                    trigger="click"
                    open={open}
                    onOpenChange={handleOpenChange}
                >
                    {access === "Read" &&
                        <FeatherIcon icon="eye" size={20} />}
                    {access === "Read,Update" &&
                        <FeatherIcon icon="edit" size={20} />}
                    {access === "Read,Update,Delete" &&
                        <FeatherIcon icon="file-minus" size={20} />}
                    {access === "Read,Update,Delete,Sharing" &&
                        <FeatherIcon icon="share-2" size={20} />}
                    <FeatherIcon icon="chevron-down" size={20} style={{ marginLeft: 5 }} />
                </Popover>
            </Col>
        </Row >
    )
}

AutoCompletes.propTypes = {
    setAccess: PropTypes.func.isRequired,
    access: PropTypes.string.isRequired,
    setSendTo: PropTypes.func.isRequired,
    dataSource: PropTypes.arrayOf(PropTypes.object),
    allDetails: PropTypes.arrayOf(PropTypes.object),
};

export { AutoCompletes };
